module.exports = __webpack_public_path__ + "media/images/ringrevenue/bg_th_light-082e59178b8fc7924d3b20ccce5b341c.gif";